var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSurgery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64409 2.57112L6.42959 3.571L5.42971 1.7855L6.42959 0L4.64409 0.999881L2.85859 0L3.85847 1.7855L2.85859 3.571L4.64409 2.57112ZM13.2145 9.57029L11.429 8.57041L12.4289 10.3559L11.429 12.1414L13.2145 11.1415L15 12.1414L14.0001 10.3559L15 8.57041L13.2145 9.57029ZM15 0L13.2145 0.999881L11.429 0L12.4289 1.7855L11.429 3.571L13.2145 2.57112L15 3.571L14.0001 1.7855L15 0ZM9.55065 3.77812C9.27211 3.49958 8.82216 3.49958 8.54362 3.77812L0.208904 12.1128C-0.0696346 12.3914 -0.0696346 12.8413 0.208904 13.1199L1.88013 14.7911C2.15867 15.0696 2.60862 15.0696 2.88716 14.7911L11.2147 6.46352C11.4933 6.18498 11.4933 5.73503 11.2147 5.45649L9.55065 3.77812ZM8.81502 7.69908L7.30092 6.18498L9.04357 4.44233L10.5577 5.95643L8.81502 7.69908Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSurgery);
export default __webpack_public_path__ + "static/media/ic-surgery.fa44dff925fcf026a031b10f9bba5e3f.svg";
export { ForwardRef as ReactComponent };